import ErrorBoundary from '@components/ErrorBoundary';
import { jwtDecode } from 'jwt-decode';
import { createContext, useEffect, useState } from 'react';

const SessionContext = createContext();

const SessionProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('jwtToken');
  };

  useEffect(() => {
    const checkAuth = () => {
      const storedToken = localStorage.getItem('jwtToken');
      if (storedToken) {
        setToken(storedToken);
        setIsAuthenticated(true);
      }
      setLoading(false);
    };

    checkAuth();

    // Optional: Listen for storage changes across tabs
    const handleStorageChange = (e) => {
      if (e.key === 'jwtToken') {
        checkAuth();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  useEffect(() => {
    const checkToken = () => {
      const token = localStorage.getItem('jwtToken');
      if (token) {
        try {
          const decodedToken = jwtDecode(token);
          const currentTime = Date.now() / 1000;
          if (decodedToken.exp < currentTime) {
            handleLogout();
          } else {
            setIsAuthenticated(true);
            setToken(token);
          }
        } catch (error) {
          handleLogout();
        }
      } else {
        handleLogout();
      }
      setLoading(false);
    };

    checkToken();

    const interval = setInterval(checkToken, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <SessionContext.Provider
      value={{ isAuthenticated, loading, setIsAuthenticated, token, handleLogout }}
    >
      <ErrorBoundary>{children}</ErrorBoundary>
    </SessionContext.Provider>
  );
};

export { SessionContext, SessionProvider };
